import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Practice } from '../interfaces/practice';

@Injectable({
  providedIn: 'root'
})
export class PracticeService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/practices/'
  }
     getListPractices(): Observable<Practice[]> {
      return this.http.get<Practice[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
     getAvailablePractices(idstudent?: number): Observable<Practice[]> {
      const query = idstudent ? `?idstudent=${idstudent}` : '';
      return this.http.get<Practice[]>(`${this.myAppUrl}${this.myApiUrl}available${query}`);
     }
     /*getListPractices2(): Observable<Practice[]> {
      return this.http.get<Practice[]>(`${this.myAppUrl}${this.myApiUrl}v2`);
    }*/
     deletePractice(id: number): Observable<void> {
      console.log("id en service: "+id);
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     savePractice(areacentro: Practice): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,areacentro)
     }
   
     getPractice(id: number): Observable<Practice> {
       return this.http.get<Practice>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updatePractice(id: number, areacentro: Practice): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, areacentro);
     }
     updatePracticeState(id: number, state: { state: number }): Observable<void> {
      return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}/state`, state);
    }
    habilitarDeshabilitarPracticasMasivo(): Observable<void> {
      return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}updateState`, {});
    }
    deshabilitarDeshabilitarPracticasMasivo(): Observable<void> {
      return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}disableState`, {});
    }
    }
   
